import StorageFactory from 'static/script/app/data/storage-factory';
import $ from 'static/script/libs/jquery';

export default () => {
    const isModern =
        'querySelectorAll' in document &&
        'addEventListener' in window &&
        'localStorage' in window &&
        'sessionStorage' in window;

    if (!isModern) {
        return false;
    }

    let storage = StorageFactory.local();
    let styleNodes = document.querySelectorAll('[data-cache-name]');

    function loadCss(styleNode, url, cacheName, cacheKey) {
        $.ajax({ method: 'GET', url: url }).done(function (result) {
            storage.clearByPrefix(cacheName);
            storage.set(cacheKey, result);
            styleNode.innerHTML = result;
        });
    }

    for (let i = 0, j = styleNodes.length; i < j; ++i) {
        let styleNode = styleNodes[i];
        let cacheName = 'tradera.fonts.' + styleNode.getAttribute('data-cache-name');
        let url = styleNode.getAttribute('data-cache-url');
        let cacheKey = cacheName + '.' + url;

        let cachedCss = storage.get(cacheKey);

        if (cachedCss) {
            break;
        }

        loadCss(styleNode, url, cacheName, cacheKey);
    }
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/boot/boot-load-fonts.js